export default __webpack_public_path__ + "static/media/selected-tag-icon.4d7ac2b9.svg";